<template>
  <div id="app">
    <div class="print-container">
      <pdf-content
        key="print-container"
        :report-data="reportData"
        :loading="loading"
      />
    </div>
    <div class="non-modal-container">
      <pdf-content
        :report-data="reportData"
        :loading="loading"
      />
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary" @click="downloadPdf">列印</button>
      </div>
    </div>
  </div>
</template>

<script>
import PdfContent from "./PdfContent";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import axiosIns from "@/libs/axios";

export default {
  name: "app",

  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  props: {
    client_loan_id: {
    },
  },
  setup(props) {
    const reportList = ref([]);
    const reportData = ref(null);
    const loading = ref(false);


    const refetchData = () => {
      loading.value = true;
      axiosIns
        .get("/contract/payment_schedule", {
          params: {
            client_loan_id: props.client_loan_id,
          },
        })
        .then((response) => {
          reportData.value = response.data.contract;
          console.log('reportData', reportData.value)
          loading.value = false;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            reportList.value = undefined;
          }
          loading.value = false;
        });
    };

    const loanTypeOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          loan_type: true,
        })
        .then((response) => {
          loanTypeOptions.value = response.data.loan_types;
        });
    };

    refetchOption();
    refetchData();

    return {
      reportList,
      reportData,
      refetchData,
      loanTypeOptions,
      loading,
    };
  },
  methods: {
    downloadPdf() {
      // 设置默认文件名
      const defaultFileName = `供款表_${new Date().toISOString().slice(0,10)}`;
      // 提示用户输入文件名
      // const fileName = window.prompt('請輸入文件名稱:', defaultFileName);
      
      // if (fileName) {
        // 设置打印时的文件名
        const style = document.createElement('style');
        style.innerHTML = `
          @page {
            margin: 0mm 10mm;
          }
          @media print {
            html, body {
              height: 100%;
            }
          }
        `;
        document.head.appendChild(style);
        
        window.document.title = defaultFileName;
        window.print();
        
        // 打印完成后恢复原标题
        setTimeout(() => {
          document.head.removeChild(style);
          window.document.title = 'X Data';
        }, 100);
      // }
    },
  },

  components: {
    PdfContent,
  },
};
</script>

<style lang="scss" scoped>
</style>